"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./TextLink.scss");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _excluded = ["element", "children", "hideUnderline", "iconLeft", "iconRight", "customIconLeft", "customIconRight", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The type of element you need. `a` or `Link` (from react router) are the most common.
   *
   * Example usage with React Router:<br>
   * `<TextLink element={Link} to="/somepage">Some content</TextLink>` */
  element: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.object]),

  /** Children  */
  children: _propTypes.node.isRequired,

  /** Reverse behavior of the underline. If set to true the underline will be hidden by default and appear on hover.  */
  hideUnderline: _propTypes.bool,

  /** Adds an icon to the left of the text */
  iconLeft: _propTypes.element,

  /** Adds an icon to the right of the text */
  iconRight: _propTypes.element,

  /** Add your own custom class names to the component */

  /** Place custom icon before text. */
  customIconLeft: _propTypes.string,

  /** Place custom icon after text. */
  customIconRight: _propTypes.string,
  className: _propTypes.string
};
var defaultProps = {
  hideUnderline: false,
  element: 'a'
};
/**
 * TextLink creates a customizable link with the element of your choice.
 * @visibleName Text Link
 */

var TextLink = function TextLink(_ref) {
  var Element = _ref.element,
      children = _ref.children,
      hideUnderline = _ref.hideUnderline,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      customIconLeft = _ref.customIconLeft,
      customIconRight = _ref.customIconRight,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-link', {
    'rds-link--no-underline': hideUnderline
  }, className);
  return /*#__PURE__*/_react.default.createElement(Element, _extends({
    className: componentClassNames
  }, rest), (iconLeft || customIconLeft) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    component: iconLeft,
    customIconPath: customIconLeft,
    className: "rds-link__icon-left"
  }), children, (iconRight || customIconRight) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    component: iconRight,
    customIconPath: customIconRight,
    className: "rds-link__icon-right"
  }));
};

TextLink.propTypes = propTypes;
TextLink.defaultProps = defaultProps;
var _default = TextLink;
exports.default = _default;